import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ChevronLeft, AlertCircle, CheckCircle2 } from 'lucide-react';
import { AcShieldLogo } from '../../components/security/AcShieldLogo';

export function CancelarEmailPage() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    setLoading(true);
    // Simula a requisição de opt-out
    setTimeout(() => {
      setLoading(false);
      setSubmitted(true);
    }, 1000);
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: '#F5F0E8', // var(--cream)
      color: '#4A4540', // var(--gray-700)
      fontFamily: "'Inter', -apple-system, sans-serif",
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      padding: '40px 20px'
    }}>
      {/* Header com Logo e Voltar */}
      <div style={{
        width: '100%',
        maxWidth: '600px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '40px',
        borderBottom: '1px solid #E8E0D4', // var(--cream-dark)
        paddingBottom: '20px'
      }}>
        <Link to="/" style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          color: '#1B365D', // var(--navy)
          textDecoration: 'none',
          fontSize: '0.9rem',
          fontWeight: 600,
          transition: 'color 0.2s'
        }}
        onMouseEnter={(e) => e.currentTarget.style.color = '#2A4A7F'}
        onMouseLeave={(e) => e.currentTarget.style.color = '#1B365D'}
        >
          <ChevronLeft size={18} />
          Voltar ao Início
        </Link>

        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{ width: 28, height: 28, color: '#1B365D' }}>
            <AcShieldLogo style={{ width: '100%', height: '100%' }} />
          </div>
          <span style={{ fontSize: '1.2rem', fontWeight: 800, color: '#1B365D' }}>
            Aluno <strong style={{ color: '#B86B47' }}>Conectado</strong>
          </span>
        </div>
      </div>

      {/* Container Principal */}
      <main style={{
        width: '100%',
        maxWidth: '600px',
        background: '#FFFFFF', // var(--white)
        border: '1px solid #E8E0D4',
        borderRadius: '16px',
        boxShadow: '0 8px 30px rgba(27, 54, 93, 0.08)', // var(--shadow-md)
        overflow: 'hidden'
      }}>
        {/* Banner de Imagem Fixo */}
        <div style={{
          width: '100%',
          height: '180px',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <img 
            src="/assets/images/hero.png" 
            alt="Cancelamento" 
            style={{ 
              width: '100%', 
              height: '100%', 
              objectFit: 'cover' 
            }} 
          />
          <div style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(to top, rgba(220, 53, 69, 0.9) 0%, rgba(27, 54, 93, 0.4) 100%)'
          }}></div>
        </div>

        <div style={{ padding: '40px', textAlign: 'center' }}>
        {!submitted ? (
          <>
            <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '56px', height: '56px', borderRadius: '50%', background: 'rgba(220, 53, 69, 0.08)', color: '#DC3545', marginBottom: '24px' }}>
              <Mail size={26} />
            </div>

            <h1 style={{ fontSize: '1.6rem', fontWeight: 800, color: '#1B365D', margin: '0 0 12px 0' }}>
              Cancelar Recebimento de E-mails
            </h1>
            
            <p style={{ fontSize: '0.92rem', lineHeight: '1.6', color: '#4A4540', marginBottom: '28px' }}>
              Caso não queira mais receber notificações escolares transacionais automáticas (como alertas de entrada/saída por RFID, notas e boletins) do <strong>Aluno Conectado</strong>, informe seu e-mail cadastrado abaixo.
            </p>

            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px', textAlign: 'left' }}>
              <div>
                <label style={{ display: 'block', fontSize: '0.75rem', fontWeight: 700, color: '#8A8478', textTransform: 'uppercase', marginBottom: '6px', letterSpacing: '0.5px' }}>
                  Endereço de E-mail
                </label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="exemplo@dominio.com"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    borderRadius: '8px',
                    background: '#FAFAF8',
                    border: '1px solid #D9D4CA',
                    color: '#1A1815',
                    fontSize: '0.9rem',
                    outline: 'none',
                    boxSizing: 'border-box',
                    transition: 'border-color 0.2s'
                  }}
                  onFocus={(e) => e.target.style.borderColor = '#1B365D'}
                  onBlur={(e) => e.target.style.borderColor = '#D9D4CA'}
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                style={{
                  width: '100%',
                  padding: '14px',
                  borderRadius: '8px',
                  background: '#DC3545', // var(--danger)
                  color: '#FFFFFF',
                  border: 'none',
                  fontSize: '0.95rem',
                  fontWeight: 700,
                  cursor: 'pointer',
                  transition: 'background 0.2s',
                  marginTop: '8px'
                }}
                onMouseEnter={(e) => e.currentTarget.style.background = '#bd2130'}
                onMouseLeave={(e) => e.currentTarget.style.background = '#DC3545'}
              >
                {loading ? 'Processando...' : 'Confirmar Cancelamento (Opt-Out)'}
              </button>
            </form>

            <div style={{
              display: 'flex',
              gap: '10px',
              marginTop: '24px',
              padding: '14px',
              background: 'rgba(184, 107, 71, 0.05)',
              border: '1px solid rgba(184, 107, 71, 0.15)',
              borderRadius: '8px',
              textAlign: 'left',
              fontSize: '0.82rem',
              color: '#B86B47',
              lineHeight: '1.5'
            }}>
              <AlertCircle size={22} style={{ flexShrink: 0, marginTop: '2px' }} />
              <span>
                <strong>Atenção:</strong> Ao cancelar, você deixará de receber alertas transacionais importantes sobre a presença e segurança física do aluno na escola. Esta ação é definitiva e exige recadastro pela coordenação para ser revertida.
              </span>
            </div>
          </>
        ) : (
          <div style={{ padding: '20px 0' }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '56px', height: '56px', borderRadius: '50%', background: 'rgba(139, 168, 136, 0.1)', color: '#6B8B68', marginBottom: '24px' }}>
              <CheckCircle2 size={32} />
            </div>

            <h1 style={{ fontSize: '1.6rem', fontWeight: 800, color: '#1B365D', margin: '0 0 12px 0' }}>
              Cancelamento Confirmado!
            </h1>
            
            <p style={{ fontSize: '0.95rem', lineHeight: '1.6', color: '#4A4540', marginBottom: '28px' }}>
              O e-mail <strong style={{ color: '#1A1815' }}>{email}</strong> foi adicionado à nossa lista de opt-out com sucesso. Nenhuma mensagem ou notificação transacional será disparada para este destinatário.
            </p>

            <Link
              to="/"
              style={{
                display: 'inline-block',
                padding: '12px 28px',
                borderRadius: '8px',
                background: '#1B365D',
                color: '#FFFFFF',
                textDecoration: 'none',
                fontSize: '0.9rem',
                fontWeight: 600,
                transition: 'background 0.2s'
              }}
              onMouseEnter={(e) => e.currentTarget.style.background = '#2A4A7F'}
              onMouseLeave={(e) => e.currentTarget.style.background = '#1B365D'}
            >
              Voltar à Página Inicial
            </Link>
          </div>
        )}
        </div>
      </main>

      {/* Footer Mínimo */}
      <footer style={{ 
        marginTop: '40px', 
        fontSize: '0.8rem', 
        color: '#8A8478', 
        textAlign: 'center', 
        lineHeight: '1.8',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '12px'
      }}>
        <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', justifyContent: 'center' }}>
          <Link to="/" style={{ color: '#8A8478', textDecoration: 'none', fontWeight: 600 }}>Início</Link>
          <span>•</span>
          <Link to="/sobre" style={{ color: '#8A8478', textDecoration: 'none', fontWeight: 600 }}>Sobre Nós</Link>
          <span>•</span>
          <Link to="/politica-de-privacidade" style={{ color: '#8A8478', textDecoration: 'none', fontWeight: 600 }}>Política de Privacidade</Link>
          <span>•</span>
          <Link to="/cancelar-email" style={{ color: '#8A8478', textDecoration: 'none', fontWeight: 600 }}>Cancelar Recebimento</Link>
        </div>
        <div>
          <span>Avenida Portugal, 4340, Sala 101, Jardim Atlântico, Belo Horizonte - MG, CEP 31710-434</span>
          <span style={{ margin: '0 8px' }}>|</span>
          <span>Contato: (31) 3274-9340 | contato@alunoconectado.com.br</span>
        </div>
        <p style={{ margin: 0 }}>&copy; 2026 Aluno Conectado. Desenvolvido por AC3 Soluções Tecnológicas Ltda.</p>
      </footer>
    </div>
  );
}
